import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { DxDataGridComponent } from 'devextreme-angular';
import { Observable, Subscription } from 'rxjs';
import { LoadResult, PhotoPdaDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { EnvService } from 'src/environments/environment';
import { ControlPanelStore } from 'src/states/control-panel.store';
import { PhotosPdaDatagridComponent } from './datagrid/photospda.datagrid.component';
import { PhotosPdaService } from 'src/api/services';

@Component({
  selector: 'app-select-photo-popup',
  templateUrl: './select-photo-popup.component.html',
  styleUrls: ['./select-photo-popup.component.css']
})
export class SelectPhotoPopupComponent implements OnInit {
  @Select(ControlPanelStore.parcId$) parcId$: Observable<number>;

  @ViewChild('photosDataGrid') photosDataGrid: PhotosPdaDatagridComponent;

  parcId: number = null;

  @Input() public Visible: boolean;
  @Output() onClosed = new EventEmitter();

  p: Subscription;

  selectedPhotos = [];

  public initHeaderFilter = false;
  public parcHeaderFilter: any;
  
  constructor(
    private translate: TranslateService,
    private envService: EnvService,
    private panelLayoutService: PanelLayoutService,
    private devExtremeTranslationService: DevExtremeTranslationService
  ) {
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.panelLayoutService.LoadTranslation().subscribe(() => {
      this.parcHeaderFilter = this.panelLayoutService.GetParcFilter('ParcId');
    });

    this.p = this.parcId$.subscribe( x => {
      if(x) {
        this.parcId = x;
        this.parcHeaderFilter = this.parcHeaderFilter.filter(p => p.value[2] == this.parcId);
      }
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.p?.unsubscribe();
  }

  onDatagridLoaded(event: LoadResult) {
    if(!this.initHeaderFilter) {
      this.photosDataGrid.dataGrid.instance.beginUpdate();
      this.photosDataGrid.dataGrid.instance.columnOption(1,'sortOrder', "desc");
      if (this.parcId != null) {
        this.photosDataGrid.dataGrid.instance.columnOption(0, 'filterValues', ['!', ['ParcId', '=', this.parcId]]);
      }
      this.photosDataGrid.dataGrid.instance.endUpdate();
      this.initHeaderFilter = true;
    }
  }
  
  onShowing() {
    this.selectedPhotos = [];
    if(this.photosDataGrid.dataGrid.instance) {
      this.photosDataGrid.dataGrid.instance.clearSelection();
    }
  }

  getUrlPhoto(data: PhotoPdaDto) {
    return data && data.Id != null ? this.envService.apiUrl + PhotosPdaService.PhotoPdaGetPhotoPdaPath.replace('{photoPdaId}', data.Id.toString()) : "";
  }

  cancelClicked() {
    this.Visible = false;
    this.onClosed.emit();
  }

  saveClicked() {
    this.Visible = false;
    this.onClosed.emit(this.selectedPhotos);
  }

  OnSelectedRowsChanged = (ids: string[]): void => {
    this.selectedPhotos = ids;
  }

}
